import Image from 'next/image'
import bookConsultation from '@publicAssets/images/ui/bookConsultation.webp'
import Process from '@publicAssets/images/ui/Process.webp'
import { useEffect, useState } from 'react'

const QualityAndProcess = () => {
  return (
    <div className="flex flex-col w-full lg:justify-center gap-5">
      {/* Quality Description */}
      <div className="flex flex-col lg:flex-row lg:justify-end lg:items-center 3xl:justify-start 3xl:gap-5">
        <div className="w-5/6 mx-auto lg:mx-0 relative h-[calc(100vw*0.6)] lg:hidden">
          <Image
            src={bookConsultation}
            alt="Book consultation"
            objectFit="cover"
            layout="fill"
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/2 p-8 lg:p-0 lg:px-8 xl:pr-28 3xl:p-0 3xl:pr-28 lg:text-right text-center 3xl:justify-center 3xl:text-right">
          <h1 className="font-normal font-heading text-2xl md:text-3.5xl leading-10">
            Providing Prompt Service, <br className="hidden 2xl:block" />
            Exceptional Quality and Excellent Prices
          </h1>
          <p className="text-base font-normal leading-8 mt-11">
            Yadav Diamonds and Jewelry is a family-run and operated store that’s{' '}
            <br className="hidden 2xl:block" />
            established trust and served customers worldwide. We take pride in
            providing <br className="hidden 2xl:block" />
            jewelry of the highest quality and are proud to put our name on it
            because we <br className="hidden 2xl:block" />
            understand the significance that stands behind each piece we make.
          </p>
        </div>
        <div className="lg:w-[calc(50vw-10px)] h-[calc(50vw*0.6)] relative mlg:hidden 2xl:ml-auto 3xl:ml-[-10px] 3xl:w-[950px] 3xl:h-[471px]">
          <Image
            src={bookConsultation}
            alt="Book consultation"
            objectFit="cover"
            layout="fill"
          />
        </div>
      </div>
      {/* Process Description */}
      <div className="flex flex-col lg:flex-row 2xl:mb-[117px] lg:items-center justify-start 3xl:justify-end">
        <div className="w-5/6 mx-auto lg:mx-0 lg:w-[calc(50vw-10px)] h-[calc(100vw*0.6)] lg:h-[calc(50vw*0.6)] relative 3xl:w-[950px] 3xl:h-[471px] 3xl:mr-[10px]">
          <Image
            src={Process}
            alt="Book consultation"
            objectFit="cover"
            layout="fill"
          />
        </div>
        <div className="flex flex-col lg:w-[50%] w-full p-8 lg:p-0 lg:px-8 xl:pl-28 lg:text-left text-center 3xl:text-left 3xl:p-0 3xl:justify-center 3xl:pl-28">
          <h1 className="font-normal font-heading text-2xl md:text-3.5xl leading-10">
            Our Process
          </h1>
          <p className="text-base font-normal leading-8 mt-11">
            We work with the most reputable vendors worldwide, so you never have
            to settle for <br className="hidden 2xl:block" />
            something you are not 100% satisfied with.{' '}
            <b className="hidden 2xl:block" />
            Each and every one of our rings & jewelry pieces are manufactured in
            the U.S. and is made <br className="hidden 2xl:block" />
            to order for the exact diamond you select. This process ensures that
            your diamond and <br className="hidden 2xl:block" />
            setting fit together in perfect harmony.
          </p>
        </div>
      </div>
    </div>
  )
}

export default QualityAndProcess
